import { FormattedMessage } from 'react-intl'

import './LoginButton.css'

export default function LoginButton() {
  return (
    <a
      target="_blank"
      href="https://app.datalab.adigital.org/login"
      className="login-button button"
      rel="noreferrer"
    >
      <span>
        <FormattedMessage id="login" />
      </span>
    </a>
  )
}
